import client from './client'
import type { NotificationConfig, NotificationSettings, Preferences } from '../types'

export async function getPreferences(): Promise<Preferences> {
  const { data } = await client.get<Preferences>('/api/v1/notifications')
  return data
}

export async function updateSettings(settings: Partial<NotificationSettings>): Promise<NotificationSettings> {
  const { data } = await client.put<NotificationSettings>('/api/v1/notifications/settings', settings)
  return data
}

export async function addOrUpdateChannel(channel: NotificationConfig): Promise<NotificationConfig[]> {
  const { data } = await client.post<NotificationConfig[]>('/api/v1/notifications/channels', channel)
  return data
}

export async function deleteChannel(channelId: string): Promise<void> {
  await client.delete(`/api/v1/notifications/channels/${channelId}`)
}
